export enum StartState {
  Standard,
  Open
}
